export type ConnectionOverlayView =
  | 'hidden'
  | 'connecting'
  | 'interrupted'
  | 'reload';

export function resolveConnectionOverlayView(input: {
  connectionStatus: string;
  isSkyxNew: boolean;
  reloadRequired: boolean;
}): ConnectionOverlayView {
  if (input.reloadRequired || input.connectionStatus === 'failed') {
    return 'reload';
  }
  if (input.connectionStatus === 'connected') {
    return 'hidden';
  }
  if (input.connectionStatus === 'idle') {
    return input.isSkyxNew ? 'connecting' : 'hidden';
  }
  if (input.connectionStatus === 'connecting') {
    return 'connecting';
  }
  if (
    input.connectionStatus === 'reconnecting' ||
    input.connectionStatus === 'disconnected'
  ) {
    return 'interrupted';
  }
  return 'hidden';
}

export function shouldLatchReloadOverlay(
  elapsedInterruptedMs: number,
  thresholdMs: number
): boolean {
  return elapsedInterruptedMs >= thresholdMs;
}
